import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LooseObject } from '../objects/loose-object';
import { filled } from '../shared/utils/common';
import { sprintf } from 'sprintf-js';
import { Observable } from 'rxjs';

const kBaseUrl: string = environment.url + '/link/';

@Injectable()
export class ContractService {

  constructor(
    private http: HttpClient,
  ) {}

  /**
   * retrieve inspection checklist for asset type id
   */
  getInspectionChecklist(assetTypeId: string) {
    let body = new URLSearchParams();
    body.append('is_view', '1');
    body.append('asset_type_id', assetTypeId);

    return this.http.post(environment.url + '/asset_types/inspection_checklists', body.toString());
  }

  /**
   * get all related recurring job compiled by per asset type based on site id
   */
  getRecurringJobPerAssetType(siteId: string = null, contractId: string = null): Observable<any> {
    let body = new URLSearchParams();

    if (filled(siteId)) {
      body.append('site_id', siteId);
    }

    if (filled(contractId)) {
      body.append('contract_id', contractId);
    }

    return this.http.post(`${environment.url}/recurring_jobs/per_asset_type`, body.toString(), { observe: 'response' });
  }

  getRecurringInvoiceGroupBySite(siteId: string = null, contractId: string = null): Observable<any> {
    let body = new URLSearchParams();

    if (filled(siteId)) {
      body.append('site_id', siteId);
    }

    if (filled(contractId)) {
      body.append('contract_id', contractId);
    }

    return this.http.post(`${environment.url}/recurring_invoices/group_by_site`, body.toString(), { observe: 'response' });
  }
}